<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col>
        <paginated-table :data="news" :columns="tableColumns" :title="$t('title.membernews_management')"
          @updatePagination="updatePagination"></paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import { getMemberNewsColumns } from "@/views/ContentView/columns";
import { deleteMemberNewsPopup, success } from '@/views/ContentView/popups';

import { boardApi } from "@/api/api";

const service_hp_url = process.env.VUE_APP_SERVICE_HP_URL;

export default {
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      // fields & columns 
      tableColumns: getMemberNewsColumns({
        description: this.handleShowDescription,
        delete: this.handleDelete,
      }),

      // boolean
      isLoading: false,

      // init data
      boardIdx: 2,
      news: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
    }
  },
  methods: {
    /**
     * *******************************************************************************************
     *  버튼 액션
     * *******************************************************************************************
     */
    async handleDelete(post) {
      const isConfirmed = await deleteMemberNewsPopup(post);

      if (!isConfirmed) {
        return;
      }
      const isDeleted = await this.deletePost(post);

      if (isDeleted) {
        await this.fetchPosts();
        await success();
      }
    },
    async handleShowDescription(post) {
      const url = `${service_hp_url}/notice/membernews/${post.idx}`;
      window.open(url, "_blank");
    },

    /**
     * *******************************************************************************************
     *  API 요청
     * *******************************************************************************************
     */

    // 목록 조회
    async fetchPosts() {
      const params = {
        board_idx: this.boardIdx,
        size: this.news.page_info.size,
        page: this.news.page_info.page,
      }

      this.isLoading = true;
      try {
        const response = await boardApi.getPosts(params);
        if (response && response.status === 200) {
          this.news = response.data.response;
          return true;
        }
        return false;
      } catch {
        return false;
      } finally {
        this.isLoading = false;
      }
    },


    // 게시글 삭제
    async deletePost(post) {
      try {
        const response = await boardApi.deletePost(post);

        if (response && response.status === 204) {
          return true;
        }
        return false;
      } catch {
        return false;
      }
    },

    /**
     * *******************************************************************************************
     *  기타 메서드
     * *******************************************************************************************
     */

    /**
     * Pagination 타입 명세
     * @typedef {Object} Conditions
     * @property {string} page - 페이지
     * @property {string} size - 사이즈
     * @property {string} total_elements - 전체 데이터 수 
     * @property {string} total_pages - 전체 페이지 수
     */

    /** 
     * 페이지네이션 업데이트 메서드
     *  
     * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
     * @params {Pagination} pagination
     */
    updatePagination(pagination) {
      this.news.page_info.size = pagination.size;
      this.news.page_info.page = pagination.page;

      this.fetchPosts();
    },

  },
  mounted() {
    this.fetchPosts();
  },
};
</script>

<style lang="css" scoped></style>